module.exports = __webpack_public_path__ + "static/media/badge_locked.192a4f22.png";